// extracted by mini-css-extract-plugin
export default {"gglogo":"NavBar_gglogo__GTpMg","toolpbar":"NavBar_toolpbar__V2GlQ"};